import { AfterViewInit, Component, Input, Output, EventEmitter } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-map',
  template: '<div id="map" class="map"></div>',
  styles: [`
    .map {
      height: 300px;
      width: 100%;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
    }
  `],
  standalone: false
})
export class MapComponent implements AfterViewInit {
  lat: number;
  lng: number;
  @Output() locationSelected = new EventEmitter<{lat: number, lng: number}>();

  @Input() set coordinates(coords: {lat: number, lng: number}) {
    this.lat = coords.lat;
    this.lng = coords.lng;
    if (this.map) {
      this.updateMapPosition();
    }
  }
  
  private map: L.Map;
  private marker: L.Marker;

  ngAfterViewInit() {
    this.initMap();
  }

  private initMap() {
    if (this.map) {
      return;
    }

    const iconRetinaUrl = 'assets/marker-icon-2x.png';
    const iconUrl = 'assets/marker-icon.png';
    const shadowUrl = 'assets/marker-shadow.png';
    const iconDefault = L.icon({
      iconRetinaUrl,
      iconUrl,
      shadowUrl,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });
    L.Marker.prototype.options.icon = iconDefault;

    this.map = L.map('map', {
      center: [this.lat || 0, this.lng || 0],
      zoom: 13,
      zoomControl: true,
      attributionControl: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(this.map);

    if (this.lat && this.lng) {
      this.marker = L.marker([this.lat, this.lng]).addTo(this.map);
    }

    setTimeout(() => {
      this.map.invalidateSize();
    }, 100);
  }

  private updateMapPosition() {
    if (this.map && this.lat && this.lng) {
      this.map.setView([this.lat, this.lng]);
      if (this.marker) {
        this.marker.setLatLng([this.lat, this.lng]);
      } else {
        this.marker = L.marker([this.lat, this.lng]).addTo(this.map);
      }
    }
  }
}
